import React from "react";
import QuickEnum from "@/scenes/OrderManagement/enum/QuickEnum";
import QuickNameMap from "@/scenes/OrderManagement/map/QuickNameMap";
import { EcSelectData } from "@/components/EcSelect/type";
import { BaseQuickField } from "@/scenes/OrderManagement/components/OrderTable/SearchPane/QuickField";
import { ButtonProps } from "antd";

interface QuickFieldProps {
    buttonProps?: ButtonProps;
}

const QuickField: React.FC<QuickFieldProps> = (props) => {
    const { buttonProps } = props;

    const options: EcSelectData<QuickEnum>[] = [
        /** 合并订单&留言备注 */
        { value: QuickEnum.QUICK_MERGE_PARENT_ORDER, label: QuickNameMap[QuickEnum.QUICK_MERGE_PARENT_ORDER] },
        { value: QuickEnum.QUICK_NOT_MERGE_ORDER, label: QuickNameMap[QuickEnum.QUICK_NOT_MERGE_ORDER] },
        { value: QuickEnum.QUICK_MANUAL_MERGER, label: QuickNameMap[QuickEnum.QUICK_MANUAL_MERGER] },
        { value: QuickEnum.QUICK_SPLIT_CHILD_ORDER, label: QuickNameMap[QuickEnum.QUICK_SPLIT_CHILD_ORDER] },
        { value: QuickEnum.QUICK_HAS_BUYER_REMARK, label: QuickNameMap[QuickEnum.QUICK_HAS_BUYER_REMARK] },
        { value: QuickEnum.QUICK_HAS_SELLER_REMARK, label: QuickNameMap[QuickEnum.QUICK_HAS_SELLER_REMARK] },
        { value: QuickEnum.QUICK_HAS_ANY_REMARK, label: QuickNameMap[QuickEnum.QUICK_HAS_ANY_REMARK] },
        { value: QuickEnum.QUICK_HAS_NO_REMARK, label: QuickNameMap[QuickEnum.QUICK_HAS_NO_REMARK] },
        { value: QuickEnum.QUICK_HAS_SUPPLIER_REMARK, label: QuickNameMap[QuickEnum.QUICK_HAS_SUPPLIER_REMARK] },

        /** 根据商品筛选&软件内是否打印 */
        {
            value: QuickEnum.QUICK_SINGLE_SKU_SINGLE_PIECE,
            label: QuickNameMap[QuickEnum.QUICK_SINGLE_SKU_SINGLE_PIECE],
        },
        {
            value: QuickEnum.QUICK_SINGLE_SKU_MULTI_PIECE,
            label: QuickNameMap[QuickEnum.QUICK_SINGLE_SKU_MULTI_PIECE],
        },
        { value: QuickEnum.QUICK_MULTI_SKU, label: QuickNameMap[QuickEnum.QUICK_MULTI_SKU] },
        { value: QuickEnum.QUICK_HAS_GIFT, label: QuickNameMap[QuickEnum.QUICK_HAS_GIFT] },
        { value: QuickEnum.QUICK_PART_SHIP, label: QuickNameMap[QuickEnum.QUICK_PART_SHIP] },
        { value: QuickEnum.QUICK_PART_CANCELED, label: QuickNameMap[QuickEnum.QUICK_PART_CANCELED] },
        { value: QuickEnum.QUICK_WAYBILL_NO_INPUTED, label: QuickNameMap[QuickEnum.QUICK_WAYBILL_NO_INPUTED] },
        { value: QuickEnum.QUICK_WAYBILL_NO_UNINPUTED, label: QuickNameMap[QuickEnum.QUICK_WAYBILL_NO_UNINPUTED] },
        {
            value: QuickEnum.QUICK_CANCEL_WAYBILL_RECYCLED,
            label: QuickNameMap[QuickEnum.QUICK_CANCEL_WAYBILL_RECYCLED],
        },
        /** 订单的发货物流类型 */
        { value: QuickEnum.QUICK_CASH_DELIVERY, label: QuickNameMap[QuickEnum.QUICK_CASH_DELIVERY] },
        { value: QuickEnum.QUICK_SHIPPING_FEE, label: QuickNameMap[QuickEnum.QUICK_SHIPPING_FEE] },
        { value: QuickEnum.QUICK_HAS_SHIPPING_FEE, label: QuickNameMap[QuickEnum.QUICK_HAS_SHIPPING_FEE] },
        { value: QuickEnum.QUICK_COUNTRY_ORDER, label: QuickNameMap[QuickEnum.QUICK_COUNTRY_ORDER] },
        { value: QuickEnum.QUICK_NO_COUNTRY_ORDER, label: QuickNameMap[QuickEnum.QUICK_NO_COUNTRY_ORDER] },
        { value: QuickEnum.QUICK_NO_SELF_PICKUP, label: QuickNameMap[QuickEnum.QUICK_NO_SELF_PICKUP] },
        { value: QuickEnum.QUICK_NOT_JD_FULFILLMENT, label: QuickNameMap[QuickEnum.QUICK_NOT_JD_FULFILLMENT] },
        {
            value: QuickEnum.QUICK_ALI_DELIVERY_GUARANTEE,
            label: QuickNameMap[QuickEnum.QUICK_ALI_DELIVERY_GUARANTEE],
        },
        /** 平台根据发货和物流打标的订单 */
        { value: QuickEnum.QUICK_EXPEDITE_DELIVERY, label: QuickNameMap[QuickEnum.QUICK_EXPEDITE_DELIVERY] },
        {
            value: QuickEnum.QUICK_REGION_BLACK_DELAY_SHIPPING,
            label: QuickNameMap[QuickEnum.QUICK_REGION_BLACK_DELAY_SHIPPING],
        },
        {
            value: QuickEnum.QUICK_DELIVERY_TIMEOUT,
            label: QuickNameMap[QuickEnum.QUICK_DELIVERY_TIMEOUT],
        },
        {
            value: QuickEnum.QUICK_SHIPPING_DEADLINE_OVERDUE,
            label: QuickNameMap[QuickEnum.QUICK_SHIPPING_DEADLINE_OVERDUE],
        },
        {
            value: QuickEnum.QUICK_SEND_ABOUT_TO_OVERDUE,
            label: QuickNameMap[QuickEnum.QUICK_SEND_ABOUT_TO_OVERDUE],
        },
        {
            value: QuickEnum.QUICK_DESIGNATED_LOGISTICS_COMPANY,
            label: QuickNameMap[QuickEnum.QUICK_DESIGNATED_LOGISTICS_COMPANY],
        },
        {
            value: QuickEnum.QUICK_SHIP_BY_SF,
            label: QuickNameMap[QuickEnum.QUICK_SHIP_BY_SF],
        },
    ];

    return <BaseQuickField options={options} buttonProps={buttonProps} />;
};

export default React.memo(QuickField);
